import { HttpClient } from "@angular/common/http";
import { Component, OnInit, Optional } from "@angular/core";
import { NzModalRef } from "ng-zorro-antd/modal";
import { AccountService } from "../../account.service";

@Component({
  selector: "v4-connect-with-agoda",
  templateUrl: "./connect-with-agoda.component.html",
  styleUrls: ["./connect-with-agoda.component.scss"],
})
export class V4ConnectWithAgodaComponent implements OnInit {
  step = 1;
  username;
  hotelIds = [{ value: null }];
  loading = false;
  constructor(
    @Optional() private modalRef: NzModalRef,
    private http: HttpClient,
    private accountSrv: AccountService,
  ) {}

  ngOnInit() {}

  private requestAuth() {
    const params = {
      username: this.username,
      hotel_ids: this.hotelIds?.map((i) => i.value),
    };
    return this.accountSrv.accountAuth("agoda", params);
    // return this.http.post("/api/thirdparty/auth/agoda", params);
  }

  onCancel() {
    this.modalRef?.destroy();
  }

  onNext() {
    this.loading = true;
    this.requestAuth().subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0) {
        // this.step = 5;
        this.modalRef?.destroy("success");
      }
    });
  }

  onFinish() {
    this.modalRef?.destroy("success");
  }

  onAddHotelId() {
    this.hotelIds.push({ value: null });
  }

  onRemoveHotelId(index) {
    this.hotelIds.splice(index, 1);
  }
}
